import React, { Fragment } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import cn from 'classnames';

import Header from 'components/Header';
import Footer from 'components/Footer';
import { Button } from 'components/Button';
import { Grid, Column } from 'components/Layout';
import TimeoutImg from 'assets/images/timeout.png';

import style from './style.scss';

const Timeout = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleButtonClick = (e) => {
    e.preventDefault();
    navigate(`/fsl/autopayelection?key=${searchParams.get('key')}`, { replace: true });
  };

  return (
    <Fragment>
      <Header />
      <section className="container">
        <div className={cn('grid-container fluid', style['borrowers-message'])}>
          <div className="grid-container">
            <Grid className="grid-margin-x max-limited">

              <Column className="small-12 large-8 large-offset-2">
                <img src={TimeoutImg} alt="timeout" />
                <h2>Your Session Timed Out</h2>
                <p className="p-large">Please click the button below to resume signing your loan document.</p>
                <Button
                  className={cn('button large red', style.button)}
                  onClick={handleButtonClick}
                >
                  Esign Now
                </Button>
              </Column>
            </Grid>
          </div>
        </div>
      </section>
      <Footer />
    </Fragment>
  );
};

export default Timeout;
